import { TableRow } from '@material-ui/core'
import React from 'react'

import style from './ClickableTableRow.module.scss'

export function ClickableTableRow(props: React.ComponentProps<typeof TableRow>) {
  return <TableRow className={style.row} {...props} />
}
